module.exports = __webpack_public_path__ + "img/card-workshop.d330c590.svg";